module.exports = __webpack_public_path__ + "img/Proliferation-MELA_SpatialResearch.5e258262.png";